import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useField } from 'formik';

import SelectFancy from '@atoms/SelectFancy';
import useStateOptions from '@hooks/useStateOptions';
import useStatesForCountry from '@hooks/useStatesForCountry';

const SelectStatesEcomm = ({ placeholder, countryFieldName, name, ...rest }) => {
    const { data: stateOptions, isLoading } = useStateOptions();
    const { getStatesForCountry } = useStatesForCountry();

    const [countryField] = useField(countryFieldName);
    const [stateField, stateMeta, stateHelpers] = useField(name);
    const [options, setOptions] = useState([]);
    const [prevCountry, setPrevCountry] = useState(countryField.value);

    // when states are loaded or country changes, update state options
    useEffect(() => {
        if (stateOptions && !countryField.value) {
            setOptions([]);
        }

        if (!stateOptions || !countryField.value) {
            return;
        }

        const newOptions = getStatesForCountry(countryField.value);
        setOptions(newOptions);
    }, [stateOptions, countryField.value]);


    return (
        <SelectFancy
            label="State/Province"
            name={name}
            isLoading={isLoading}
            options={options}
            noOptionsMessage="Please select a country to load options"
            placeholder={placeholder}
            {...rest}
        />
    );
};


export default SelectStatesEcomm;
